import { take, call } from "redux-saga/effects"
import actionTypes from "../../actions/actionTypes"
import { getEventsDataAllCall } from "../../apis/wpApi/apiCalls"
import authUser from "../../apis/wpApi/authUser"
import { checkResponse, putError, putSuccess } from "../helpers"


function* getData(payload){
    const successType = yield actionTypes.EVENTS_ALL_SUCCESS
    const errorType = yield actionTypes.EVENTS_ALL_ERROR

    try {
        const apiKey = yield call(authUser.getToken)
        const response = yield call(getEventsDataAllCall, apiKey, payload.signal)
        
        yield call(checkResponse, response, ['events', 'settings'])
        yield call(putSuccess, successType, { data: response.data})
    } catch(e){
        yield call(putError, errorType, e.message)
    }
}

function* watchEventsGetAllRequest() {
    try {
        while(true) {
            const request = yield take(actionTypes.EVENTS_ALL_REQUEST)

            yield call(getData, request.payload)
        }

    } catch(e) {
        console.log('error!!!!!', e.message)
    }
}


export default watchEventsGetAllRequest;